import { assertArray, assertObject, assertString } from "core/validation";
import { cloneDeep, get, isEqual } from "lodash";
import { createSelectorCreator, lruMemoize } from "reselect";

export function sortArrayByDate(array, fieldName, desc = false) {
    if (!assertArray(array)) {
        return array;
    }
    const sorted = cloneDeep(
        array.sort((a, b) => {
            const date1 = a[fieldName];
            const date2 = b[fieldName];
            return compareDatesAsc(date1, date2);
        })
    );

    return desc ? sorted.reverse() : sorted;
}

export function compareDatesAsc(date1, date2) {
    const dateA = new Date(date1);
    const dateB = new Date(date2);
    return dateA - dateB;
}

export const createDeepEqualSelector = createSelectorCreator({
    memoize: lruMemoize,
    memoizeOptions: {
        equalityCheck: isEqual,
        resultEqualityCheck: isEqual
    }
});


export function mapToSelectValues(items, config, collection) {
    if (!assertArray(items)) {
        return [];
    }
    const array = cloneDeep(items);
    return array.map((item) => {
        if (typeof item === "number" && collection.length) item = collection.find((c) => c.id === item);
        return mapToSelectValue(item, config);
    });
}


export function mapToSelectValue(item, config) {
    const value = get(config, "value", "id");
    const label = get(config, "label", "name");
    const valueKey = get(config, "valueKey", "value");
    const labelKey = get(config, "labelKey", "label");
    if (!assertObject(item)) {
        return null;
    }
    const r = { ...item };
    switch (typeof value) {
    case "string":
        if (item[value]) {
            r[valueKey] = item[value];
        }
        break;
    case "function":
        r[valueKey] = value(item);
        break;
    default:
        break;
    }

    switch (typeof label) {
    case "string":
        if (item[label]) {
            r[labelKey] = item[label];
        }
        break;
    case "function":
        r[labelKey] = label(item);
        break;
    default:
        break;
    }

    return r;
}

export function contactHasEmail(c) {
    return assertArray(c.addresses) && c.addresses[0] && assertString(c.addresses[0].email);
}
export function contactToAddress(c) {
    const email = c.addresses[0].email;
    return contactHasEmail(c) ? `${c.firstName} ${c.lastName} <${email}>` : null;
}
export function mapContactsToAddress(list) {
    return list.filter((c) => assertString(contactHasEmail(c))).map((c) => contactToAddress(c));
}
